import React from 'react';
import { withRouter } from 'react-router-dom';
import queryString from 'query-string';
import { get, isEmpty  } from 'lodash';

import { ToDoItemDetailWidgetService } from 'services/toDoItemDetailWidget';
import { toDoItemDetailWidget as ToDoItemDetailWidgetView } from 'ui/views/widgets/toDoItemDetailWidget';
import { DASHBOARD } from 'constants/route-paths';
import { SERVICE_RESPONSE_STATUS } from 'constants/common';

/**
 * @type {class}
 * @desc A React container/smart component to render a React presentational/dumb component (view).
 * @example
 * import { ToDoItemDetailWidget } from 'ui/containers/ToDoItemDetailWidget';
 *
 * // render
 * <ToDoItemDetailWidget propName='propValue'/>
 */
export class _ToDoItemDetailWidget extends React.Component {
    
    /**
     * @param {object} props - props
     */
    constructor( props ) {
        super( props );

        this.toDoItemDetailWidgetService = new ToDoItemDetailWidgetService();
        const queryParams = queryString.parse( this.props.location.search );

        this.handleNavActionClick = this.handleNavActionClick.bind( this );

        this.state = {
            isFetching: true,
            networkStatus: undefined,
            taskId: get( queryParams, 'taskId' ),
            componentData: undefined,
        };

        // if - `taskId` is not present, redirect to the dashboard landing
        // else - make service request for the component data
        if ( isEmpty( this.state.taskId ) ) {
            this.props.history.replace( DASHBOARD );
        } else {
            this.fetchComponentData(); // start component data fetch
        }
    }

   /**
    * @desc Fetch component response.
   */
    async fetchComponentData() {
        log.debug( 'ToDoItemDetailWidgetView.fetchComponentData()' );

        // cancel ongoing request
        this.toDoItemDetailWidgetService.cancel();

        // get status and service data
        const { status, data } = await this.toDoItemDetailWidgetService.fetchComponentData( {
            url: this.props.widget.url
        } );
        
        // check if response status was success
        if( SERVICE_RESPONSE_STATUS.SUCCESS !== status ) {
            this.setState( {
                isFetching: false,
                networkStatus: SERVICE_RESPONSE_STATUS.FAILURE
            } );
        } else {
            this.setState( {
                isFetching: false,
                networkStatus: SERVICE_RESPONSE_STATUS.SUCCESS,
                componentData: data,
            } );
        }
    }

    handleNavActionClick( { type, value } ) {
        log.debug( 'ToDoItemDetailWidgetView.handleNavActionClick()' );

        if(  'headerAction' === type && 'back' === value.name ) {
            this.props.history.goBack();
        }
    }

    /**
     * @desc Render a React view component
     */
    render() {
        return (
            <ToDoItemDetailWidgetView
                isFetching={ this.state.isFetching }
                networkStatus={ this.state.networkStatus }
                taskId={ this.state.taskId }
                { ...get( this.state, 'componentData', {} ) }
                requestPayload = { {
                    context: {
                        taskId: this.state.taskId
                    }
                } }
                onNavActionClick={ this.handleNavActionClick }
            />
        );
    }
}

// set display name
_ToDoItemDetailWidget.displayName = 'ToDoItemDetailWidget';

// set default props
_ToDoItemDetailWidget.defaultProps = {};

// prop types
_ToDoItemDetailWidget.propTypes = {};

export const ToDoItemDetailWidget = withRouter( _ToDoItemDetailWidget );
